import api from '../apis/api';

export const getUser = async () => {
  const resp = await api.get(`/user`);
  return resp.data;
};
